/**
 * Convert number to money
 *
 * @example
 * money(1000000)
 * // => 'Rp1.000.000'
 *
 * @param  {Number|String} val Number to convert
 * @param  {String} options
 * @return {String} Converted number in money format
 */

const defaultOptions = {
  currency: 'Rp',
};

function money(val, customOptions = {}) {
  const options = {
    ...defaultOptions,
    ...customOptions,
  };

  const int = (parseInt(val, 10) || 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const fraction = Math.abs(val % Math.floor(Math.abs(val))) || 0;
  const fractionStr =
    fraction > 0
      ? fraction
          .toFixed(2) // Delimit only 2 digits based on PUEBI
          .slice(1)
          .replace('.', ',')
      : '';
  if (int.charAt(0) === '-') {
    return int.replace(/^-/g, `-${options.currency}`) + fractionStr;
  }
  return `${options.currency}${int}${fractionStr}`;
}

module.exports = money;
